module.exports = __webpack_public_path__ + "img/project5.8fb93268.jpg";